module.exports = __webpack_public_path__ + "26e974722aedf8d9d3c3ef6651f970ef.pdf";